// extracted by mini-css-extract-plugin
export var container = "index-module--container--1m9Rw";
export var grid = "index-module--grid--34xwY";
export var card = "index-module--card--v0N83";
export var intro = "index-module--intro--26Vo5";